import React from 'react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Share2 } from 'lucide-react';

/**
 * Share a community question. Uses the native share sheet when available,
 * otherwise copies the canonical on-site link to the clipboard.
 * The URL always points back to the question on the website so the
 * conversation continues here.
 */
const ShareButton = ({ path, title = 'Ask a Social Worker', testid = 'share-btn', variant = 'outline', className = '', label = 'Share' }) => {
  const buildUrl = () => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}${path || '/community/ask-a-social-worker'}`;
  };

  const handleShare = async () => {
    const url = buildUrl();
    const shareData = { title, text: `${title} — join the conversation on I Need A Social Worker`, url };
    if (navigator.share) {
      try { await navigator.share(shareData); return; } catch (e) { if (e?.name === 'AbortError') return; }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied — share it anywhere. It opens the conversation here.');
    } catch (e) {
      toast.error('Could not copy the link.');
    }
  };

  return (
    <Button type="button" variant={variant} onClick={handleShare} className={className} data-testid={testid}>
      <Share2 className="w-4 h-4 mr-2" /> {label}
    </Button>
  );
};

export default ShareButton;
